export default __webpack_public_path__ + "static/media/particleHeartSecondary.1c70cdf5.svg";